import { render, staticRenderFns } from "./breadCrumbs.vue?vue&type=template&id=24c2d8ca&scoped=true&"
import script from "./breadCrumbs.vue?vue&type=script&lang=js&"
export * from "./breadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./breadCrumbs.vue?vue&type=style&index=0&id=24c2d8ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2d8ca",
  null
  
)

export default component.exports